const cards = [
  {
    title: '91免费在线视频 · 每日精选',
    desc: '编辑团队精心挑选每日最值得观看的91免费在线视频内容，涵盖多元题材，确保每一次点击都是高品质体验。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20atmospheric%20scene%20with%20soft%20red%20and%20gold%20lighting%2C%20abstract%20geometric%20composition%2C%20velvet%20texture%2C%20luxurious%20dark%20aesthetic%2C%20entertainment%20mood%2C%20no%20explicit%20content&width=800&height=500&seq=card-img-01&orientation=landscape',
    tag: '热门',
  },
  {
    title: '91福利在线视频频道 · 品质之选',
    desc: '91福利在线视频汇集平台最优质资源，从海量内容中层层筛选，只为给你最好的免费视频在线观看体验。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20dark%20theater%20atmosphere%20with%20warm%20amber%20glow%2C%20abstract%20curtain%20like%20shapes%2C%20cinematic%20lighting%2C%20sophisticated%20entertainment%20vibe%2C%20no%20people%2C%20artistic&width=800&height=500&seq=card-img-02&orientation=landscape',
    tag: '精选',
  },
  {
    title: '免费视频在线观看 · 新手引导',
    desc: '第一次来91麻豆免费视频网站？这份新手观看指南帮你快速找到91免费视频网站中最适合你的内容分类。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20minimal%20abstract%20background%20with%20soft%20gradients%20of%20crimson%20and%20gold%2C%20smooth%20textures%2C%20cinematic%20feel%2C%20artistic%20composition%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=card-img-03&orientation=landscape',
    tag: '指南',
  },
  {
    title: '免费高清视频在线 · 画质标杆',
    desc: '追求极致画质？免费高清视频在线频道提供全平台最高清的播放体验，1080P蓝光级画质让视觉享受升级。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20luxurious%20abstract%20scene%20with%20rich%20velvet%20textures%20and%20warm%20lighting%2C%20elegant%20geometric%20patterns%2C%20sophisticated%20evening%20atmosphere%2C%20no%20people&width=800&height=500&seq=card-img-04&orientation=landscape',
    tag: '高清',
  },
  {
    title: '91在线观看视频网站 · 移动优先',
    desc: '91在线观看视频网站全面适配移动端，手机浏览器直接访问即可畅享所有内容，无需下载也能流畅观看。',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20composition%20with%20soft%20glowing%20elements%2C%20dark%20background%20with%20red%20and%20amber%20accents%2C%20cinematic%20atmosphere%2C%20artistic%20texture%2C%20no%20people&width=800&height=500&seq=card-img-05&orientation=landscape',
    tag: '移动',
  },
  {
    title: '91福利视频在线 · 持续更新中',
    desc: '91福利视频在线频道保持高频更新节奏，每天都有新内容上线，让你每次访问都能发现惊喜，永不错过精彩。',
    img: 'https://readdy.ai/api/search-image?query=Luxurious%20dark%20abstract%20art%20with%20crimson%20and%20gold%20gradients%2C%20soft%20glowing%20accents%2C%20theater%20like%20atmosphere%2C%20cinematic%20mood%2C%20no%20explicit%20content&width=800&height=500&seq=card-img-06&orientation=landscape',
    tag: '更新',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 text-center mb-2">精选专题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">91麻豆免费视频网站精心策划的专题内容，带你深入了解平台核心价值</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, i) => (
            <a
              key={i}
              href="#media"
              className="group block bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-[16/10] bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs font-medium bg-primary-500 text-white px-2.5 py-0.5 rounded-full">{card.tag}</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}